import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Switch from '@mui/material/Switch';

import SendIcon from '@mui/icons-material/Send';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

import ConfirmButton from '@ts-core/components/ConfirmButton';

const AssignmentListCardActions = (props) => {
  const { assignment, loading, onToggleAssignment, onRemoveAssignment, onEditAssignment, onSendAssignment } = props;

  const handleSendAssignment = useCallback(() => {
    onSendAssignment(assignment);
  }, [onSendAssignment, assignment]);

  const handleToggleAssignment = useCallback(() => {
    onToggleAssignment(assignment);
  }, [onToggleAssignment, assignment]);

  const handleRemoveAssignment = useCallback(() => {
    onRemoveAssignment(assignment);
  }, [onRemoveAssignment, assignment]);

  const handleEditAssignment = useCallback(() => {
    onEditAssignment(assignment);
  }, [onEditAssignment, assignment]);

  if (loading) return null;

  return (
    <>
      <Switch color="secondary" checked={assignment.enabled} onChange={handleToggleAssignment} />
      <Box flexGrow={1} />
      {!assignment.sent && (
        <ConfirmButton
          alertMessage={<FormattedMessage id="assignment.send.confirm" values={{ name: assignment.name }} />}
          onConfirm={handleSendAssignment}
        >
          {({ onClick }) => (
            <Tooltip title={<FormattedMessage id="assignment.button.send" />}>
              <IconButton onClick={onClick} size="large">
                <SendIcon />
              </IconButton>
            </Tooltip>
          )}
        </ConfirmButton>
      )}
      <Tooltip title={<FormattedMessage id="button.edit.label" />}>
        <IconButton onClick={handleEditAssignment} size="large">
          <EditIcon />
        </IconButton>
      </Tooltip>
      <ConfirmButton
        alertMessage={<FormattedMessage id="dialog.confirmRemoveItem.title" values={{ item: assignment.name }} />}
        onConfirm={handleRemoveAssignment}
      >
        {({ onClick }) => (
          <Tooltip title={<FormattedMessage id="assignment.button.remove" />}>
            <IconButton onClick={onClick} size="large">
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        )}
      </ConfirmButton>
    </>
  );
};

AssignmentListCardActions.propTypes = {
  assignment: PropTypes.object,
  loading: PropTypes.bool,

  onToggleAssignment: PropTypes.func.isRequired,
  onRemoveAssignment: PropTypes.func.isRequired,
  onSendAssignment: PropTypes.func.isRequired,
  onEditAssignment: PropTypes.func.isRequired,
};

AssignmentListCardActions.defaultProps = {
  assignment: {},
  loading: false,
};

export default AssignmentListCardActions;
